import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as display from '../../../../../display'
import type * as relay from '../../../../../relay'
import type { Plugin } from '../plugin'

/**
 * Shows the same sticky "process started" toast used by other process-backed
 * workflows once a report generation request has been accepted
 */
export const showToastOnDownloadSuccess = store.effects.create(
  (
    feature: Plugin['feature'],
    toasterFeature: display.toaster.Feature,
    processesFeature: relay.processes.Feature,
  ) =>
    feature.actions.download.success.observe().pipe(
      rxjs.map(action =>
        toasterFeature.actions.show.from(action).create({
          toast: {
            actions: [
              {
                callback: () => {
                  processesFeature.actions.openSlideout
                    .from('SpaceReportDownload.Success.Toast')
                    .dispatch()
                },
                closeOnClick: true,
                id: 'view-processes',
                kind: 'button',
                name: 'View processes',
              },
            ],
            description:
              'Your report is being generated. Download it from the processes list once it is ready.',
            durationMs: null,
            name: 'Report generation started',
          },
        }),
      ),
    ),
)
